// Mock Leaderboards Data
// Extracted from CommunityLeaderboard.tsx

export interface LeaderboardRanking {
  rank: number;
  contributorId?: string;
  recipeId?: string;
  displayName: string;
  value: number;
  change: number;
  badge?: string;
  highlight: boolean;
}

export interface CommunityLeaderboard {
  id: string;
  period: string;
  category: string;
  rankings: LeaderboardRanking[];
  updatedAt: string;
}

export const mockLeaderboards: CommunityLeaderboard[] = [
  {
    id: 'most_liked',
    period: 'weekly',
    category: 'most_liked',
    rankings: [
      {
        rank: 1,
        contributorId: 'contrib-1',
        displayName: 'Chef Maria Rodriguez',
        value: 2847,
        change: 156,
        badge: '👑',
        highlight: true
      },
      {
        rank: 2,
        contributorId: 'contrib-2',
        displayName: 'Grandmother Betty',
        value: 2103,
        change: 89,
        badge: '🥈',
        highlight: false
      },
      {
        rank: 3,
        contributorId: 'contrib-3',
        displayName: 'Healthy Chef Sam',
        value: 1756,
        change: 234,
        badge: '🥉',
        highlight: false
      },
      {
        rank: 4,
        displayName: 'Pasta Master Tony',
        value: 1542,
        change: 67,
        highlight: false
      },
      {
        rank: 5,
        displayName: 'Vegan Vibes Sarah',
        value: 1389,
        change: -23,
        highlight: false
      }
    ],
    updatedAt: new Date().toISOString()
  },
  {
    id: 'most_saved',
    period: 'weekly',
    category: 'most_saved',
    rankings: [
      {
        rank: 1,
        recipeId: 'recipe-1',
        displayName: 'Grandma\'s Apple Pie',
        value: 2341,
        change: 89,
        badge: '📌',
        highlight: true
      },
      {
        rank: 2,
        recipeId: 'recipe-2',
        displayName: 'Mediterranean Herb Chicken',
        value: 1876,
        change: 156,
        badge: '📌',
        highlight: false
      },
      {
        rank: 3,
        recipeId: 'recipe-3',
        displayName: 'Perfect Sourdough Starter',
        value: 1654,
        change: 234,
        badge: '📌',
        highlight: false
      }
    ],
    updatedAt: new Date().toISOString()
  },
  {
    id: 'most_cooked',
    period: 'weekly',
    category: 'most_cooked',
    rankings: [
      {
        rank: 1,
        recipeId: 'recipe-4',
        displayName: '15-Minute Weeknight Pasta',
        value: 1234,
        change: 78,
        badge: '👨‍🍳',
        highlight: true
      },
      {
        rank: 2,
        recipeId: 'recipe-5',
        displayName: 'One-Bowl Chocolate Chip Cookies',
        value: 987,
        change: 45,
        badge: '👨‍🍳',
        highlight: false
      }
    ],
    updatedAt: new Date().toISOString()
  },
  {
    id: 'most_ai_contributions',
    period: 'weekly',
    category: 'most_ai_contributions',
    rankings: [
      {
        rank: 1,
        contributorId: 'contrib-4',
        displayName: 'Data Detective Dan',
        value: 2450,
        change: 340,
        badge: '🧠',
        highlight: true
      },
      {
        rank: 2,
        contributorId: 'contrib-1',
        displayName: 'Chef Maria Rodriguez',
        value: 1890,
        change: 156,
        badge: '🧠',
        highlight: false
      }
    ],
    updatedAt: new Date().toISOString()
  }
]; 